import { TRIGGER_NON_BP_MERCHANT_INFO_API, TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS } from 'redux/actionTypes';

export function triggerNonBpMerchantInfoApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_NON_BP_MERCHANT_INFO_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerNonBpMerchantInfoApiCallSuccess(data) {
	return {
		type: TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS,
		data,
	};
}
